import { Injectable } from '@angular/core';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import {
  IOnboardingRegistrationLocalStorageProps,
  OnboardingBusinessConfigPaymentsDataProps,
  OnboardingBusinessConfigScheduleDataProps,
  OnboardingBusinessConfigServicesDataProps,
  OnboardingBusinessConfigSocialNetworksDataProps,
  OnboardingRegistrationGmbDataProps,
  OnboardingRegistrationModel,
  OnboardingRegistrationUserDataProps,
  ONBOARDING_BUSINESS_CONFIG_KEY,
  ONBOARDING_REGISTRATION_KEY,
} from '../..';
import {
  ModulesConfig,
  ModulesConfigLocalStorageProps,
  OnboardingBusinessConfigGmbStatusDataProps,
  OnboardingBusinessConfigNotificationsDataProps,
  OnboardingBusinessConfigWebsiteDataProps,
} from '../models/BusinessConfig.model';

@Injectable()
export class OnboardingLStorageService {
  constructor(private localStorage: LocalStorageNativeService) {}

  /********************** START OF REGISTRATION METHODS **********************
   ***************************************************************************/
  async getOnboardingRegistrationData(): Promise<IOnboardingRegistrationLocalStorageProps | null> {
    const obDataStr = await this.localStorage.getItem(
      ONBOARDING_REGISTRATION_KEY
    );
    const obData = (
      obDataStr
        ? new OnboardingRegistrationModel(JSON.parse(obDataStr))
        : OnboardingRegistrationModel.empty()
    ) as IOnboardingRegistrationLocalStorageProps;
    return obData;
  }

  async setRegistrationInfoStaging(
    payload: OnboardingRegistrationUserDataProps
  ) {
    const obData = await this.getOnboardingRegistrationData();

    obData.userData.completed = false;
    obData.userData.fields = payload;

    return this.localStorage.setItem(
      ONBOARDING_REGISTRATION_KEY,
      JSON.stringify(obData)
    );
  }

  async setRegistrationInfoCommitted() {
    const currData = await this.getOnboardingRegistrationData();
    currData.userData.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_REGISTRATION_KEY,
      JSON.stringify(currData)
    );
  }

  async setRegistrationGmbData(
    payload: {
      [key in keyof Partial<OnboardingRegistrationGmbDataProps>]: any;
    }
  ) {
    const obData = await this.getOnboardingRegistrationData();
    obData.userData.completed = false;

    Object.keys(payload).forEach((key) => {
      obData.gmbData.fields[key] = payload[key];
    });

    return this.localStorage.setItem(
      ONBOARDING_REGISTRATION_KEY,
      JSON.stringify(new OnboardingRegistrationModel(obData))
    );
  }

  // TODO: Agregar los métodos para guardar: gmbData y  subscriptionData

  // ------------------ END OF REGISTRATION METHODS -------------------------

  /******************* START OF BUSINESS CONFIG METHODS **********************
   ***************************************************************************/
  async getOnboardingBusinessConfigData(): Promise<ModulesConfigLocalStorageProps | null> {
    const obDataStr = await this.localStorage.getItem(
      ONBOARDING_BUSINESS_CONFIG_KEY
    );
    const obData = obDataStr
      ? new ModulesConfig(JSON.parse(obDataStr))
      : ModulesConfig.empty();
    return obData;
  }

  //################# SERVICES #######################
  async setBusinessConfigServicesStaging(
    payload: OnboardingBusinessConfigServicesDataProps
  ) {
    const obData = await this.getOnboardingBusinessConfigData();

    obData.services.completed = false;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(obData)
    );
  }
  async setBusinessConfigServicesCommitted() {
    const currData = await this.getOnboardingBusinessConfigData();
    currData.services.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(currData)
    );
  }

  //################# SCHEDULE #######################
  async setBusinessConfigScheduleStaging(
    payload: OnboardingBusinessConfigScheduleDataProps
  ) {
    const obData = await this.getOnboardingBusinessConfigData();

    obData.schedule.completed = false;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(obData)
    );
  }
  async setBusinessConfigScheduleCommitted() {
    const currData = await this.getOnboardingBusinessConfigData();
    currData.schedule.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(currData)
    );
  }

  //################# PAYMENTS #######################
  async setBusinessConfigPaymentsStaging(
    payload: OnboardingBusinessConfigPaymentsDataProps
  ) {
    const obData = await this.getOnboardingBusinessConfigData();

    obData.paymentMethods.completed = false;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(obData)
    );
  }
  async setBusinessConfigPaymentsCommitted() {
    const currData = await this.getOnboardingBusinessConfigData();
    currData.paymentMethods.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(currData)
    );
  }

  //################# SOCIAL NETWORKS #######################
  async setBusinessConfigSocialNetworksStaging(
    payload: OnboardingBusinessConfigSocialNetworksDataProps
  ) {
    const obData = await this.getOnboardingBusinessConfigData();

    obData.socialNetworks.completed = false;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(obData)
    );
  }
  async setBusinessConfigSocialNetworksCommitted() {
    const currData = await this.getOnboardingBusinessConfigData();
    currData.socialNetworks.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(currData)
    );
  }

  //################# GMB #######################
  async setBusinessConfigGmbStaging(
    payload: OnboardingBusinessConfigGmbStatusDataProps
  ) {
    const obData = await this.getOnboardingBusinessConfigData();

    obData.gmbStatus.completed = false;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(obData)
    );
  }
  async setBusinessConfigGmbCommitted() {
    const currData = await this.getOnboardingBusinessConfigData();
    currData.gmbStatus.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(currData)
    );
  }

  //################# NOTIFICATIONS #######################
  async setBusinessConfigNotificationsStaging(
    payload: OnboardingBusinessConfigNotificationsDataProps
  ) {
    const obData = await this.getOnboardingBusinessConfigData();

    obData.notifications.completed = false;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(obData)
    );
  }
  async setBusinessConfigNotificationsCommitted() {
    const currData = await this.getOnboardingBusinessConfigData();
    currData.notifications.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(currData)
    );
  }

  //################# WEBSITE #######################
  async setBusinessConfigWebsiteStaging(
    payload: OnboardingBusinessConfigWebsiteDataProps
  ) {
    const obData = await this.getOnboardingBusinessConfigData();

    obData.website.completed = false;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(obData)
    );
  }
  async setBusinessConfigWebsiteCommitted() {
    const currData = await this.getOnboardingBusinessConfigData();
    currData.website.completed = true;
    return this.localStorage.setItem(
      ONBOARDING_BUSINESS_CONFIG_KEY,
      JSON.stringify(currData)
    );
  }

  // ----------------- END OF BUSINESS CONFIG METHODS ------------------------
}
